import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { cookieService } from '../services';
import { cookieServiceParam } from '../utils/constants';
import { routes } from '../utils/routesConstants';

const OPTIONS = [
    {
        id: 'C',
        title: 'Crew',
        badge: 'Free',
        text: `Showcase yourself, find jobs, find crew, suppliers and
    locations manage your availability, communicate, all in one
    place. All departments, all roles, one app.`,
    },
    {
        id: 'P',
        title: 'Production Company',
        badge: 'Free',
        text: `Sign up as a production company to manage crew schedules, workflows, messages and reporting.`,
    },
    {
        id: 'S',
        title: 'Supplier',
        text: `Third party suppliers, create your profile, list your services,
    products, connect with crew, and put yourself in front of
    industry leading professionals.`,
        infoIcon: true,
    },
    {
        id: 'L',
        title: 'Locations',
        badge: 'Coming Soon',
        text: `List your film location with us, we will send a scout to you
    for high quality photos, and also connect you directly with
    crew, no agents, no commission, one fixed annual fee.`,
    },
];

const COMING_SOON_OPTIONS = ['L'];

const OnboardingStart = () => {
    const [selectedOption, setSelectedOption] = useState('C');
    const navigate = useNavigate();

    useEffect(() => {
        cookieService.removeCookie(cookieServiceParam.userType);
    }, []);

    const handleNext = useCallback(() => {
        if (!selectedOption) return;

        if (COMING_SOON_OPTIONS.includes(selectedOption)) {
            alert('To be implemented!');
            return;
        }

        cookieService.saveCookie(cookieServiceParam.userType, selectedOption);

        if (selectedOption === 'P') {
            navigate('/sign-in', { state: { is_production_owner: true } })
            return
        }

        navigate(selectedOption == 'C' ? routes.crew_signup : routes.supplier_signup);

    }, [selectedOption, navigate]);

    const cards = useMemo(() => OPTIONS, []);

    return (
        <div className="onboarding-start">
            <div className="onboarding-start-left">

                {/* Top Section */}
                <div className="onboarding-start-top">
                    <button
                        type="button"
                        className="onboarding-start-member-btn"
                        onClick={() => navigate('/sign-in')}
                    >
                        Already a member?

                        <img
                            src="/assets/images/onboarding_profile.png"
                            alt="member"
                            className="onboarding-start-member-icon"
                        />
                    </button>
                </div>

                {/* Content */}
                <div className="onboarding-start-content">

                    {/* Heading */}
                    <div className="onboarding-start-heading-block">
                        <h1 className="onboarding-start-title">
                            Create your
                            <br />
                            profile
                        </h1>

                        <div className="onboarding-start-description">
                            <p>
                                We need you to help us with some basic information for your
                                account creation. Here are our{' '}
                                <Link to={`${routes.legals}/tnc`}>Terms & Conditions</Link>. Please read them carefully.
                                We are GDPR compliant, and only share the data you want us to,
                                per our <Link to={`${routes.legals}/pp`}>Privacy Policy</Link>.
                            </p>
                        </div>
                    </div>

                    <div className="onboarding-start-divider" />

                    {/* Cards */}
                    <div className="onboarding-start-card-grid">
                        {cards.map((card) => {
                            const isSelected = selectedOption === card.id;

                            return (
                                <button
                                    key={card.id}
                                    type="button"
                                    className={`onboarding-start-card ${isSelected
                                        ? 'onboarding-start-card-active'
                                        : ''
                                        }`}
                                    onClick={() => setSelectedOption(card.id)}
                                >
                                    {card.badge && (
                                        <span className="onboarding-start-card-badge">
                                            {card.badge}
                                        </span>
                                    )}

                                    {card.infoIcon && (
                                        <img
                                            src="/assets/images/onboardingInfo.png"
                                            alt="info"
                                            className="onboarding-start-card-info"
                                        />
                                    )}

                                    <h3 className="onboarding-start-card-title">
                                        {card.title}
                                    </h3>

                                    <p className="onboarding-start-card-text">
                                        {card.text}
                                    </p>

                                    {isSelected && (
                                        <span className="onboarding-start-card-check">
                                            <img
                                                src="/assets/images/onboarding_check.png"
                                                alt="selected"
                                            />
                                        </span>
                                    )}
                                </button>
                            );
                        })}
                    </div>

                    <div className="onboarding-start-divider onboarding-start-divider-bottom" />

                    {/* Footer */}
                    <div className="onboarding-start-footer">
                        <button
                            type="button"
                            className="onboarding-start-next-btn"
                            onClick={handleNext}
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>

            {/* Right Section */}
            <div className="onboarding-start-right">
                <img
                    src="/assets/images/film-set.png"
                    alt="film production"
                    className="onboarding-start-image"
                />

                <div className="onboarding-start-year">
                    <img
                        src="/assets/images/yellow-6th.png"
                        alt="logo"
                    />
                </div>
            </div>
        </div>
    );
};

export default React.memo(OnboardingStart);